import type { MeOut } from "@manapp/api-client"
import { createContext, useContext } from "react"

export type OrgContextValue = {
  me: MeOut
  organizationId: string
  role: "admin" | "project_manager" | "worker"
  /** Capabilities in the active organization, for display only: the server enforces every check. */
  capabilities: readonly string[]
  timeZone: string
}

export const OrgContext = createContext<OrgContextValue | null>(null)

export function useOrg(): OrgContextValue {
  const value = useContext(OrgContext)
  if (!value) throw new Error("OrgContext missing")
  return value
}
